export default function Login() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      gap: '2rem',
    }}>
      {/* Logo / titre */}
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontSize: '3rem',
          marginBottom: '0.5rem',
          filter: 'drop-shadow(0 0 20px rgba(232,71,63,0.4))',
        }}>🛡️</div>
        <h1 style={{
          fontFamily: 'var(--font-ui)',
          fontWeight: 800,
          fontSize: '2rem',
          letterSpacing: '-0.02em',
          color: 'var(--text)',
        }}>CrowdSec Manager</h1>
        <p style={{ color: 'var(--muted)', marginTop: '0.4rem', fontFamily: 'var(--font-mono)', fontSize: '0.8rem' }}>
          Gestion des bans et alertes
        </p>
      </div>

      {/* Card */}
      <div style={{
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        padding: '2.5rem 3rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.5rem',
        minWidth: '320px',
      }}>
        <p style={{ color: 'var(--muted)', fontSize: '0.9rem', textAlign: 'center' }}>
          Connexion réservée aux membres de l'organisation
        </p>

        <a href="/auth/login" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          background: '#fff',
          color: '#1a1a1a',
          border: 'none',
          borderRadius: 'var(--radius)',
          padding: '0.75rem 1.5rem',
          fontFamily: 'var(--font-ui)',
          fontWeight: 700,
          fontSize: '0.95rem',
          cursor: 'pointer',
          textDecoration: 'none',
          transition: 'transform 0.15s, box-shadow 0.15s',
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        }}
          onMouseOver={e => e.currentTarget.style.transform = 'translateY(-1px)'}
          onMouseOut={e => e.currentTarget.style.transform = 'none'}
        >
          <GoogleIcon />
          Se connecter avec Google
        </a>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  );
}
